import { compose, withHandlers, withProps } from "recompose";
import ProposalForm from "./ProposalForm";
import { SubmissionError } from "redux-form";
import { connectProposalActions } from "./hocs";
import { UPDATE } from "./constants";

const onSubmit = props => values => {
  const { updateDraft } = props;
  const proposal = { ...values };
  delete proposal.ui;
  proposal.modified = new Date(); // This is just for the UI
  return updateDraft({ proposal }).catch(error => {
    if (error && error.type === UPDATE.ERROR) {
      throw new SubmissionError({ _error: error });
    }
    throw error;
  });
};

const configure = compose(
  withProps(props => {
    const { proposal } = props;
    return {
      initialValues: proposal
    };
  }),
  connectProposalActions,
  withHandlers({
    onSubmit
  })
);

export default configure(ProposalForm);



// WEBPACK FOOTER //
// ./src/app/proposals/ProposalUpdateForm.js